import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormDataRedux, {
  selectApplicationPanelInfo,
} from '../../../Redux/FormDataRedux';

import SectionSingleCol from '../../../common/SectionSingleCol';
import OneDigitalHeroSection from './OneDigitalHeroSection';
import ActionCardSection from '../../../common/ActionCardSection';
import AboutSection from './AboutSection';
import SecureActSection from '../SectionSMBCosts';
import CostSavingsSection from './CostSavingsSection';
import CallToActionSection from './CallToActionSection';
import QuestionSection from './QuestionSection';
import PurpleSection from './PurpleSection';

import { DivStyled } from './index.styles';
import {
  OneDigitalHomeHero,
  OneDigitalLogo,
  WomanOnComputerSmiling,
} from '../../../ImagePaths';
import { asOfDate, oneDigInvestmentCost } from '../../../Services/utilities';
import TwoColCircleImg from '../TwoColCircleImg';
import { GrowthPlatform } from '../../../common/GrowthPlatform';

const sectionHero = {
  title: `<div>
          <img src="${OneDigitalLogo}" alt="OneDigital logo" class="w-16" />
          <h1 class="fs-display1 mb-md-4 mb-0">
            <span class="text-white">Small business retirement plans made simple</span>
          </h1>
        </div>`,
  image: OneDigitalHomeHero,
  caption: `<h2 class="fs-h2 text-white fw-normal d-md-block d-none">
              Help your employees gain financial security.
            </h2>`,
  copy: '',
};

const calltoactionData = [
  {
    id: 1,
    icon: `<svg height="75" enable-background="new 0 0 100 100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" role="img" aria-labelledby="piggyTitle piggyDesc"><title id="piggyTitle">Piggy Bank Icon</title><desc id="piggyDesc">Piggy bank icon: Learn about the basics of retirement plans.</desc><linearGradient id="a1"><stop offset="0" stop-color="#0191da"/><stop offset="1" stop-color="#019c94"/></linearGradient><linearGradient id="b1" gradientTransform="matrix(.959 -.2835 .2835 .959 -7.2329 26.8754)" gradientUnits="userSpaceOnUse" x1="89.0085" x2="89.0085" xlink:href="#a1" y1="30.7427" y2="44.2153"/><linearGradient id="c1" gradientUnits="userSpaceOnUse" x1="42.3497" x2="42.3497" xlink:href="#a1" y1="19.07" y2="81.3865"/><linearGradient id="d1" gradientUnits="userSpaceOnUse" x1="52.5005" x2="52.5005" xlink:href="#a1" y1="26.5574" y2="30.7932"/><linearGradient id="e1" gradientUnits="userSpaceOnUse" x1="21.8993" x2="21.8993" xlink:href="#a1" y1="38.3833" y2="42.4468"/><g clip-rule="evenodd" fill="none" stroke-miterlimit="10" stroke-width="3"><g stroke-linejoin="round"><path d="m82.9 44.2s11.2.1 7.5-8.7c-2.1-5-9.4-2.3-6.7 2.6s12.3-2.4 12.3-2.4" stroke="url(#b1)" stroke-linecap="round"/><path d="m78.4 59c1.6-2.9 2.9-6.6 3.1-10.7 0-7.6-3.4-14.6-8.7-19.5-5.5-5.1-12.8-8.2-20.6-8.2-9 0-17.7 3.4-23.1 9.9-.4.4-.9 1.1-1.2 1.1s-2.6-4-3.4-4.9c-.8-1-1.7-1.8-2.8-2.3-1.6-.8-3.4-1.1-4.9-1.2.5 1.2 1 2.5 1.2 3.7.8 2.7 1.1 5.4 1.1 5.4l-7.5 9.6c-.3.3-.7.5-1.1.5l-7.4.8v1.4c0 1.1 0 2.7.1 4.9 0 .4.3 1 .7 1.6.4.7 1.1 1.5 2 2.3 1.6 1.6 4 3.4 6.4 5.1 4.8 3.2 10 5.9 11.1 6.5.1.1.3.1.3.1.5.3 1 1 1 1.6v13l4.2.1s.8-2.3 1.2-3.4c.8-2.2 1.6-4.3 1.6-4.3.4-1 1.4-1.4 2.3-1.1 4.4 1.5 8.6 2.1 12.4 2.1 7.4 0 12.6-1.9 12.8-2.1.4-.3 1-.3 1.4 0s.8.7 1 1.1c.3.8.9 2 1.5 3.3.2.4 2.4 4.3 2.4 4.3h5.6v-13c0-.7.4-1.4 1-1.6 2.4-1.1 4.5-3.2 6.3-6.1z" stroke="url(#c1)"/><path d="m44.4 29c2.5-.7 4.9-1 7.5-1 3 0 5.9.4 8.6 1.2" stroke="url(#d1)" stroke-linecap="round"/></g><path d="m22.4 40.4c0 .3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5z" stroke="url(#e1)"/></g></svg>`,
    excerpt: 'Learn the basics of retirement plans.',
    caption:
      'Find out how to help employees save for the future and what’s involved in managing a plan.',
    actionText: 'Learn about retirement plans',
    actionPath: 'onedigital/learn-the-basics',
  },
  {
    id: 2,
    icon: `<svg height="75" enable-background="new 0 0 100 100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" role="img" aria-labelledby="magTitle magDesc"><title id="magTitle">Magnifying glass icon</title><desc id="magDesc">Magnifying glass icon: Compare retirement savings options.</desc><linearGradient id="a2"><stop offset="0" stop-color="#0091da"/><stop offset=".474" stop-color="#0096b7"/><stop offset="1" stop-color="#009c91"/></linearGradient><linearGradient id="b2" gradientUnits="userSpaceOnUse" x1="31.2678" x2="31.2678" xlink:href="#a2" y1="14.2463" y2="28.1706"/><linearGradient id="c2" gradientUnits="userSpaceOnUse" x1="68.036" x2="68.036" xlink:href="#a2" y1="47.8317" y2="90.5018"/><linearGradient id="d2" gradientUnits="userSpaceOnUse" x1="36.9385" x2="36.9385" xlink:href="#a2" y1="8.0686" y2="59.8589"/><g fill="none" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4"><path d="m39.9 15.7c-.3 0-.4 0-.7 0-4.4 0-8.9 1.7-12.3 5-1.8 1.7-3.3 3.8-4.3 6" stroke="url(#b2)"/><path d="m49.9 56.4 26.7 29.8.9 1c1 1.1 2.3 1.7 3.7 1.7 1.2 0 2.5-.5 3.5-1.4 1.1-1 1.7-2.4 1.7-3.8-.1-1.4-.6-2.6-1.4-3.7l-.7-.8-27.1-29.9" stroke="url(#c2)"/><ellipse cx="36.9" cy="34" rx="24.3" ry="24.4" stroke="url(#d2)"/></g></svg>`,
    excerpt: 'Compare retirement savings options.',
    caption: `See how Simply Retirement by Principal<sup><small>&reg;</small> </sup>stacks up against other types of plans.`,
    actionText: 'Compare options',
    actionPath: 'onedigital/retirement-plans#401k-table', // 401k-table
  },
  {
    id: 3,
    icon: `<svg height="75" enable-background="new 0 0 100 100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" role="img" aria-labelledby="computerTitle computerDesc"><title id="computerTitle">Man at computer icon</title><desc id="computerDesc">Man at computer icon: Find out if a 401(k) plan fits your needs</desc><linearGradient id="a3"><stop offset="0" stop-color="#0398b9"/><stop offset="1" stop-color="#029c94"/></linearGradient><linearGradient id="b3" gradientUnits="userSpaceOnUse" x1="50" x2="50" xlink:href="#a3" y1="91.6027" y2="56.2358"/><linearGradient id="c3" gradientUnits="userSpaceOnUse" x1="17.0551" x2="17.0551" xlink:href="#a3" y1="78.2541" y2="81.2541"/><linearGradient id="d3" gradientUnits="userSpaceOnUse" x1="82.9449" x2="82.9449" xlink:href="#a3" y1="78.2541" y2="81.2541"/><linearGradient id="e3" gradientUnits="userSpaceOnUse" x1="50" x2="50" xlink:href="#a3" y1="42.4743" y2="79.5889"/><linearGradient id="f3" gradientUnits="userSpaceOnUse" x1="50" x2="50" xlink:href="#a3" y1="7.6579" y2="45.2266"/><g fill="none" stroke-miterlimit="10" stroke-width="4"><g stroke-linecap="round" stroke-linejoin="round"><path d="m29.3 57.7h41.4v32.4h-41.4z" stroke="url(#b3)"/><path d="m28.7 79.8h-23.3" stroke="url(#c3)"/><path d="m94.6 79.8h-23.3" stroke="url(#d3)"/></g><path d="m18.5 78.2v-14.8s.1-19.4 31.1-19.4 31.9 19.4 31.9 19.4v16.2" stroke="url(#e3)"/><circle cx="50" cy="26.4" r="17.3" stroke="url(#f3)" stroke-linecap="round" stroke-linejoin="round"/></g></svg>`,
    excerpt: 'Find out if this 401(k) plan fits your needs.',
    caption:
      'Give us a few details and see what a 401(k) plan might look like for you.',
    actionText: 'Try our planner',
    actionPath: 'onedigital/plans#begin',
  },
];

const whyUsSection = {
  heading: `
  <h3 class="fs-h3 mb-md-3 mb-5 mr-4 mr-md-0">
    Are your employees saving enough for retirement?
  </h3>
`,
  copy: `
  <p class="fs-h6">
    Making ends meet and saving for retirement at the same time can
    be a challenge for today’s employees. Many don’t have a plan or
    haven’t saved even a fraction of what they would need to retire
    comfortably. <strong>At Principal<small><sup>®</sup></small> and OneDigital Investment Advisors (“OneDigital”), we're aiming to fix that.</strong>
  </p>
  <p class="fs-h6 mb-3">
    As a business owner, you can help start your employees on a path
    to a better future. A Simply Retirement by Principal<small><sup>®</sup></small> 401(k) plan with OneDigital advisory services can be an easy way for them to save money now with the potential to have it grow over the years so they can enjoy retirement.
  </p>
  `,
};

const oneDigitalHomeDisclaimer1 = `
  <p class="fs-disclaimer-print">
    SECURE 2.0 Act legislation allows small businesses with up to 50 employees a tax credit of 100% and those with 51-100 a tax credit of 50% of the qualifying start-up costs for a new employee retirement plan for the first three years of the plan as follows but limited to the greater of (1) $500 or (2) the lesser of (a) $250 for each non-highly compensated employee who is eligible to participate in the plan or (b) $5,000.
  </p>
  <p>
  New tax credit for start-up plans offering employer contributions: A tax credit equal to the applicable percentage of employer contributions, capped at a maximum of $1,000 per employee.
  <ul>
    <li>Applicable to small employers with 50 or fewer employees.</li>
    <li>For employees with 51-100 employees: The credit is phased out by reducing the amount of credit each year 2% for each employee in excess of 50.</li>
  </ul>
  <b>Applicable Percentage:</b>
  <p>1st and 2nd year = 100%, 3rd year = 75%, 4th year = 50%, 5th year = 25%, 6th year = 0%</p>
  <p>No contributions may be counted for employees with wages in excess of $100,000 (inflation adjusted). If taking advantage of this tax credit, employer contributions may not also be counted towards “start-up costs” in the start-up tax credit calculation.</p>
  </p>  `;
const oneDigitalHomeDisclaimer2 = `
<p class="fs-disclaimer-print"><span class="d-print-block d-none">*Recordkeeping-fee:</span>Pricing shown applies when working with a TPA. Bundled pricing is a $500 initial setup fee, then $185 per month. Fees paid by the business owner are billed quarterly. Fees paid by participants are deducted monthly from participant accounts. Participant fees are charged if there is a $100 account balance, regardless of whether the participant is active or inactive. Custodial and investment fees are charged against participating employees’ accounts (those vary by investment and range from ${oneDigInvestmentCost}, as of ${asOfDate}). If the business owner chooses to work with a financial professional and/or TPA, their fees are also additional and may be billed to the business owner. Financial professional fees may be deducted from participant accounts.</p>`;
const oneDigitalHomeDisclaimer3 = `<p class="fs-disclaimer-print"><span class="d-print-block d-none">*What’s included:</span> Plan costs are billed quarterly. Custodial and investment fees are charged against participating employees’ accounts (those vary by investment and range from ${oneDigInvestmentCost}, as of ${asOfDate}). If the business owner chooses to work with a financial professional and/or TPA, their fees are separate and may be billed to the business owner. Financial professional fees may be deducted from participant accounts.</p>`;
const oneDigitalHomeDisclaimer4 = `<p class="fs-disclaimer-print"><span class="d-print-block d-none">*Principal:</span> As of ${asOfDate}</p>`;
const footNoteList = `
  <div class="row mx-0 my-5">
    <div class="col-12 text-left">
     ${oneDigitalHomeDisclaimer1}
     ${oneDigitalHomeDisclaimer2}
     ${oneDigitalHomeDisclaimer3}
     ${oneDigitalHomeDisclaimer4}
    </div>
  </div>
`;

const whatsIncludedBody = `
The $145 per month recordkeeping fee applies when working with a TPA. Bundled pricing includes a $500 initial setup fee, then $185 per month. Plan costs are billed quarterly. Custodial and investment fees are charged against participating employees’ accounts (those vary by investment and range from ${oneDigInvestmentCost}, as of ${asOfDate}). Should the business owner choose to work with a financial professional and/or TPA, their fees are also additional.
`;

const HomeContainer = ({ applicationPanelInfo, putApplicationPanelInfo }) => {
  useEffect(() => {
    const element = document.getElementById('root');
    if (applicationPanelInfo.hasVisibility) {
      document.body.classList.add('no-scroll');
      element.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
      element.classList.remove('no-scroll');
    }
  });
  return (
    <DivStyled className="smb-home">
      <OneDigitalHeroSection
        image={sectionHero.image}
        title={sectionHero.title}
        caption={sectionHero.caption}
        copy={sectionHero.copy}
        offset
      />
      <section style={{ position: 'relative', zIndex: 1 }}>
        <ActionCardSection cards={calltoactionData} />
      </section>
      <TwoColCircleImg
        heading={whyUsSection.heading}
        copy={whyUsSection.copy}
        image={WomanOnComputerSmiling}
        circleBg="bg-white"
      />

      <AboutSection
        putApplicationPanelInfo={putApplicationPanelInfo}
        businessOwnerHomeDisclaimer1={oneDigitalHomeDisclaimer1}
      />

      <SecureActSection
        title="Simply Retirement by Principal<sup><small>®</small></sup>costs"
        putApplicationPanelInfo={putApplicationPanelInfo}
        cardType="default"
        businessOwnerHomeDisclaimer2={oneDigitalHomeDisclaimer2}
        whatsIncludedBody={whatsIncludedBody}
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-10 mx-auto">
            <p className="fs-h6 text-dark fw-normal text-center">
              There&apos;s a one-time startup fee of $500, a monthly
              recordkeeping fee of $185 ($555 billed quarterly), a $6 monthly
              fee per participating employee, and OneDigital&apos;s monthly
              advisor fee of $250 ($750 billed quarterly) and 45 bps (11.25 bps
              deducted quarterly) until plan assets reach defined threshold.
            </p>
            <p className="fs-h6 text-dark fw-normal text-center">
              *Refer to your OneDigital 3(38) agreement for more details
            </p>
          </div>
        </div>
      </div>

      <CostSavingsSection />
      <PurpleSection
        putApplicationPanelInfo={putApplicationPanelInfo}
        businessOwnerHomeDisclaimer4={oneDigitalHomeDisclaimer4}
      />
      <CallToActionSection />
      <QuestionSection putApplicationPanelInfo={putApplicationPanelInfo} />
      <GrowthPlatform
        wrapperStyles="bg-concrete"
        title="Small business growth platform"
        copy="With a Simply Retirement by Principal<span><sup>®</sup></span> plan, your client has access to Elevate by Principal, a powerful network, resource, and team of people in their corner. From data-driven insights to deep discounts on products and services, that a business owner uses every day, Elevate by Principal can provide what your client needs to take their business to the next level."
      />
      <section className="section_py-5 bg-concrete">
        <p className="fs-disclaimer text-center pb-5 mb-5">
          Intended for plan sponsor use.
        </p>
      </section>
      <SectionSingleCol
        copy={footNoteList}
        columns="col-12"
        className="d-print-block d-none"
      />
      <span className="d-none">1843844-092021</span>
    </DivStyled>
  );
};

HomeContainer.propTypes = {
  applicationPanelInfo: PropTypes.object.isRequired,
  putApplicationPanelInfo: PropTypes.func.isRequired,
};

const mapStateToProps = (store) => ({
  applicationPanelInfo: selectApplicationPanelInfo(store),
});

const mapDispatchToProps = (dispatch) => ({
  putApplicationPanelInfo: (obj) => {
    dispatch(FormDataRedux.putApplicationPanelInfo(obj));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);
